export default function simulateClick(target: Element): void {
	const event: MouseEvent = new MouseEvent('click', {
		view: window,
		bubbles: true,
		cancelable: true
	});
	let cancelled: boolean = !target.dispatchEvent(event);
}